"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { useSearchLogTimer } from "@/hooks/use-search-log-timer";

interface CategorySearchBarProps {
  categorySlug: string;
}

/**
 * カテゴリ内検索バー
 * Enter でカテゴリ絞り込み付きの検索結果ページに遷移する
 */
export function CategorySearchBar({ categorySlug }: CategorySearchBarProps) {
  const [query, setQuery] = useState("");
  const router = useRouter();
  const { logOnSubmit } = useSearchLogTimer({
    query: query.trim(),
    resultCount: null,
    source: "search",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed) {
      logOnSubmit();
      router.push(`/categories/${categorySlug}?q=${encodeURIComponent(trimmed)}`);
    } else {
      router.push(`/categories/${categorySlug}`);
    }
  };

  return (
    <form
      role="search"
      aria-label="カテゴリ内検索"
      onSubmit={handleSubmit}
      style={{ maxWidth: "480px" }}
      className="w-full"
    >
      <div className="relative">
        {/* 虫眼鏡アイコン */}
        <svg
          className="pointer-events-none absolute top-1/2 -translate-y-1/2"
          style={{ left: "12px", width: "18px", height: "18px", color: "#9CA3AF" }}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="このカテゴリ内を検索..."
          className="w-full transition-all duration-200"
          style={{
            height: "44px",
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            border: "1px solid #D1D5DB",
            fontSize: "14px",
            paddingLeft: "40px",
            paddingRight: "12px",
            color: "#374151",
            outline: "none",
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = "var(--theme-primary)";
            e.currentTarget.style.boxShadow =
              "0 0 0 3px color-mix(in srgb, var(--theme-primary) 15%, transparent)";
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = "#D1D5DB";
            e.currentTarget.style.boxShadow = "none";
          }}
        />
      </div>
    </form>
  );
}
